import React from "react";
import { Container, Grid, Card, CardContent, Typography, Box } from "@mui/material";
import { School, MenuBook, Assessment, Help, Feedback, Devices } from "@mui/icons-material";
import { motion } from "framer-motion";

const advantages = [
  {
    icon: <School fontSize="large" />, title: "Teaching Methodology",
    points: ["Concept & application based learning", "Interactive & engaging lectures", "Integrated approach focusing on competitive & school exams"]
  },
  {
    icon: <MenuBook fontSize="large" />, title: "Study Material",
    points: ["Well-researched & analysed", "Comprehensive & meticulously designed", "Based on latest syllabus & exam pattern"]
  },
  {
    icon: <Assessment fontSize="large" />, title: "Regular Tests & Assessments",
    points: ["Detailed test analysis with error analysis report", "Simulated tests based on latest exam pattern", "Compete at national level with All India Aakash Test Series"]
  },
  {
    icon: <Help fontSize="large" />, title: "Doubt Clearing System",
    points: ["One-to-one interactive session with subject experts", "Detailed & simplified solutions", "Video solutions for instant doubt resolution"]
  },
  {
    icon: <Feedback fontSize="large" />, title: "Feedback System",
    points: ["Timely updates on performance & attendance", "Query/ grievance redressal"]
  },
  {
    icon: <Devices fontSize="large" />, title: "Omni-channel Learning",
    points: ["100% digitised classrooms across all branches or centres", "Hybrid classrooms offering the best of classroom & online learning", "Digital Product (Recorded Video Lectures, e-Content, e-Test Papers/Series)"]
  }
];

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};

const AakashAdvantage = () => {
  return (
    <Box sx={{ backgroundColor: "#e0f5fe", py: 5 }}>
      <Container>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }}
        >
          <Typography variant="h4" fontWeight="bold" align="center" gutterBottom sx={{fontSize:{md:30,xs:20}}}>
            Aakash Advantage
          </Typography>
          <Typography variant="h5" color="primary" align="center" gutterBottom sx={{ color: '#00b0f5', fontWeight: 'bold' }}>
            Stay ahead with all-round performance in your chosen stream
          </Typography>
        </motion.div>
        <Grid container spacing={3} justifyContent="center" sx={{ mt: 1 }}>
          {advantages.map((adv, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={cardVariants}
              >
                <Box sx={{ p: 2, borderRadius: 3,border:'2px solid #f5f5f5', height: '200px',bgcolor:'white' }}>
                  <CardContent>
                    <Box display="flex" alignItems="center" mb={1}>
                      {adv.icon}
                      <Typography variant="h6" fontWeight="bold" sx={{ ml: 1 }}>
                        {adv.title}
                      </Typography>
                    </Box>
                    {adv.points.map((point, i) => (
                      <Typography key={i} variant="body2" color="textSecondary" sx={{ mb: 0.5 }}>
                        • {point}
                      </Typography>
                    ))}
                  </CardContent>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AakashAdvantage;